<mat-sidenav-container class="sidebar-container">
  <mat-sidenav #sidenav id="sidebar" mode="side" [(opened)]="extended" (openedStart)="openStart()" (closedStart)="closedStart()"
    (opened)="openedSideBar()" (closed)="closedSidebar()">
    <div class="nav-content-container">
      <mat-nav-list class="list-sidenav">
        <ng-container *ngFor="let item of sideNavData | notProperty:'hidden'">
          <mat-expansion-panel *ngIf="hasChildren(item)" expanded="true">
            <mat-expansion-panel-header [ngClass]="{'active-route': currentRouterUrl == '/'+item.route}">
              <mat-panel-title>
                <app-sidenav-menu-item [item]="item" [showText]="true" [showTooltip]="showTooltip" (click)="handleClick(item, $event)"></app-sidenav-menu-item>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-nav-list>
              <ng-container *ngFor="let childItem of item.children | notProperty:'hidden'">
                <app-sidenav-menu-item [item]="childItem" [showText]="true" [showTooltip]="showTooltip" (click)="handleClick(childItem , $event)"></app-sidenav-menu-item>
              </ng-container>
            </mat-nav-list>

          </mat-expansion-panel>
          <app-sidenav-menu-item *ngIf="!hasChildren(item)" [item]="item" [showText]="true" [showTooltip]="showTooltip" (click)="handleClick(item, $event)"></app-sidenav-menu-item>
        </ng-container>

        <ng-container *ngFor="let item of nonRouterLinks">
          <app-sidenav-menu-item [item]="item" [showText]="true" [showTooltip]="showTooltip" (click)="handleClick(item, $event)"></app-sidenav-menu-item>
        </ng-container>
      </mat-nav-list>
      <ng-content></ng-content>
      <div class="sidenav-actions" (click)="sidenav.toggle()" *ngIf="isOpen">
        <mat-icon class="arrow-key" *ngIf="extended">keyboard_arrow_left</mat-icon>
        <mat-icon class="arrow-key" *ngIf="!extended">keyboard_arrow_right</mat-icon>
        <div class="sidenav-actions-spacer"></div>
      </div>
    </div>

  </mat-sidenav>
  <mat-sidenav-content>
    <div class="side-nav-content" [ngClass]="{'fade-in': isClosing, 'fade-out': isOpening, 'not-visible': isOpen, visible: isClosed}">
      <div class="icon-container">
        <mat-nav-list class="icons">
          <ng-container *ngFor="let item of sideNavData | notProperty:'hidden'">
            <app-sidenav-menu-item [item]="item" *ngIf="hasChildren(item)" #sideNavMenuTrigger="matMenuTrigger" [matMenuTriggerData]="{children: item.children}"
              [matMenuTriggerFor]="sideNavMenu" [showTooltip]="showTooltip" (mouseover)="expandOnHover && debounceOpenMenu(sideNavMenuTrigger)" (mouseout)="expandOnHover && endDebounceOpenMenu()"
              (click)="handleClick(item, $event, true)">
            </app-sidenav-menu-item>
            <app-sidenav-menu-item [item]="item" *ngIf="!hasChildren(item)" [showTooltip]="showTooltip" (click)="handleClick(item, $event)"></app-sidenav-menu-item>
          </ng-container>

          <ng-container *ngFor="let item of nonRouterLinks">
            <app-sidenav-menu-item [item]="item" [showTooltip]="showTooltip" (click)="handleClick(item, $event)"></app-sidenav-menu-item>
          </ng-container>
        </mat-nav-list>
      </div>
      <div class="sidenav-actions" (click)="sidenav.toggle()" *ngIf="!isOpen">
        <mat-icon class="arrow-key" *ngIf="extended">keyboard_arrow_left</mat-icon>
        <mat-icon class="arrow-key" *ngIf="!extended">keyboard_arrow_right</mat-icon>
        <div class="sidenav-actions-spacer"></div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<mat-menu #sideNavMenu="matMenu" xPosition="after" [overlapTrigger]="true" [class]="'sidebar-flyout-menu'">
  <ng-template matMenuContent let-children="children">
    <ng-container *ngFor="let childItem of children | notProperty:'hidden'">
      <div mat-menu-item *ngIf="!hasChildren(childItem)">
        <app-sidenav-menu-item [item]="childItem" [showText]="true" [showTooltip]="showTooltip" (click)="handleClick(childItem, $event, true)"></app-sidenav-menu-item>
      </div>
      <div mat-menu-item [matMenuTriggerFor]="sideNavMenu2" *ngIf="hasChildren(childItem)" [matMenuTriggerData]="{children: childItem.children}"
        (click)="handleClick(childItem, $event, true)">
        <app-sidenav-menu-item [item]="childItem" [showText]="true" [showTooltip]="showTooltip"></app-sidenav-menu-item>
      </div>
      <mat-menu #sideNavMenu2="matMenu" [overlapTrigger]="false">
        <ng-template matMenuContent let-children="children">
          <ng-container *ngFor="let childItem of children | notProperty:'hidden'">
            <div mat-menu-item (click)="handleClick(childItem, $event)">
              <app-sidenav-menu-item [item]="childItem" showText="true" [showTooltip]="showTooltip"></app-sidenav-menu-item>
            </div>
          </ng-container>
        </ng-template>
      </mat-menu>
    </ng-container>
  </ng-template>
</mat-menu>